import graphql from "babel-plugin-relay/macro";

const DocumentsForReviewCSVQuery = graphql`
  query DocumentsForReviewCSVQuery(
    $justMine: Boolean
    $includePending: Boolean
    $categories: [Int]
    $daysUntilExpiration: Int
  ) {
    documentsToReviewCsv(
      justMine: $justMine
      includePending: $includePending
      categories: $categories
      daysUntilExpiration: $daysUntilExpiration
    ) {
      taskId
    }
  }
`;

export default DocumentsForReviewCSVQuery;
